import { Button, Spinner } from "react-bootstrap";
import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import classNames from "classnames";
const useStyles = createUseStyles((theme) => ({
  button: {
    fontSize: 15,
    color: theme.authenticationBtnColor,
    width: "100%",
    height: 50,
    borderColor: `${theme.authenticationBtnBg}!important`,
    background: `${theme.authenticationBtnBg}!important`,
    padding: [0, 25],
    transition: "all 0.4s",
    borderRadius: "25px!important",
    marginBottom: 10,
    "&:hover, &:disabled": {
      background: `${theme.authenticationBtnBg}!important`,
      borderColor: `${theme.authenticationBtnBg}!important`,
    },
  },
}));

const LoadingButton = ({ children, loading, className, bg, ...rest }) => {
  const theme = useTheme();

  const styles = useStyles({ theme, bg });
  return (
    <Button className={classNames(styles.button, className)} {...rest}>
      {loading ? <Spinner animation="border" /> : children}
      {/* {children} */}
    </Button>
  );
};

export { LoadingButton };
